export const environment = {
  production: false,
  TENANT_ID:
    'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef',
  CLIENT_ID: '9d822665-267a-4ec4-83e5-f1002b928b0e',
  REDIRECT_URL: 'https://qa.lios.toyota.com',
  log_level: 'debug',
  ADMIN_DS_URI: 'https://api.qa.lios.toyota.com/admin/graphql',
  APM_DS_URI: 'https://api.qa.lios.toyota.com/apm/graphql',
  BILLING_DS_URI: 'https://api.qa.lios.toyota.com/billing/graphql',
  OPERATIONS_DS_URI : "https://api.qa.lios.toyota.com/operations/graphql",
  manifest: {
    admin: 'https://admin.qa.lios.toyota.com/remoteEntry.js',
    apm: 'https://apm.qa.lios.toyota.com/remoteEntry.js',
    bm: 'https://bm.qa.lios.toyota.com/remoteEntry.js',
    lcm: 'https://lcm.qa.lios.toyota.com/remoteEntry.js',
    cm: 'https://cm.qa.lios.toyota.com/remoteEntry.js',
    maintenance: 'https://maintenance.qa.lios.toyota.com/remoteEntry.js',
    opershell : 'https://opershell.qa.lios.toyota.com/remoteEntry.js',
    operations : 'https://operations.qa.lios.toyota.com/remoteEntry.js'
  },
};
